<!-- 小车模型经过雾灯时，屏幕右上角  呈现雾灯设置信息 -->
<template>
    <div class="container"  v-show="isShowLEDSet">
      <div class="text__box one" :style="style">主机:{{ hostGprsAddr }}</div>
      <div class="text__box two">路段:{{ hostRoad }}</div>
      <div class="text__box three">经度:{{ hostLon }}</div>
      <div class="text__box four">纬度:{{ hostLat }}</div>
      <div class="text__box five">温度:{{ hostTemp }}</div>
      <div class="text__box six">湿度:{{ hostDamp }}</div>
      <div class="text__box seven">照度:{{ hostLight }}</div>
      <div class="text__box eight">能见度:{{ hostVis }}</div>
      <div class="footer" v-show="isShowTick">
      </div>
    </div>

  </template>
  <script >
  import { reactive, ref, toRefs, onBeforeMount, onMounted, computed } from "vue";
  import  $bus  from '../bus.ts'
  export default {
    name:'DisplayLEDSet',
    data(){
        return {
            ledDatas:[],
            gprsAddr:'',
            style:{},
            hostGprsAddr:'',
            hostRoad:'',
            hostLon:'',
            hostLat:'',
            hostTemp:'',
            hostDamp:'',
            hostLight:'',
            hostVis:'',
            theTimer:'' ,
            isShowTick:false,
            isShowLEDSet:false
        }
    },
    methods:{
        LEDHostListDatas(ledDatas){
            console.log('DisplayLEDSet组件 收到LEDHostListDatas = ',ledDatas)
            this.ledDatas = ledDatas ;

        },
        LEDGpAddr(ledGpAddr){
            console.log('DisplayLEDSet组件 收到ledGpAddr = ',ledGpAddr);
            if(ledGpAddr == ''){
              this.isShowLEDSet = false;
              return ;
            }
            this.isShowLEDSet = true;
            this.gprsAddr = ledGpAddr;

            this.ledDatas.forEach((element)=>{
                console.log('DisplayLEDSet组件 element.gprsAddr = ',element.gprsAddr ,this.gprsAddr);
                if(element.gprsAddr == this.gprsAddr){
                    this.hostGprsAddr = element.gprsAddr ;
                    this.hostRoad = element.road + element.name;
                    this.hostLon = element.lon.toFixed(6);
                    this.hostLat = element.lat.toFixed(6);
                    this.hostTemp = element.temp;
                    this.hostDamp = element.dampness;
                    this.hostLight = element.brightness ;
                    this.hostVis = element.nengjiandu ;

                    console.log('DisplayLEDSet组件 element = ',element);
                    // this.style.with = 0;
                }
            })
            setTimeout(()=>{
              this.isShowTick = true ;
            },16000),
            
            this.theTimer = setTimeout(()=>{
              this.isShowTick = false;
                this.isShowLEDSet = false;
                $bus.emit('isShouldAnimate',true);               
            },17500);
        }
    },
    mounted(){
        this.$bus.on('LEDHostListDatas',this.LEDHostListDatas);
        $bus.on('LEDGpAddr',this.LEDGpAddr);
    },
    unmounted(){
        this.$bus.off('LEDHostListDatas');
        $bus.off('LEDGpAddr');
        clearTimeout(this.theTimer);
    }
  }


  </script>

  <style scoped>
  .container {
    position: absolute;
    width: 396px;
    height: 264px;
    top: 5%;
    left: 65%;
    background-color: rgba(0,0,0,0.01);
    padding: 40px 40px;
    border-radius: 10px;
    background-image: url(../assets/lineBox.png);
    background-repeat: no-repeat;
    background-size: cover;
    text-align: left;
  }
  
  .text__box {
    position: relative;
    overflow: hidden;
    color: rgb(5, 14, 67);
    width: 0;
    font-size: 16px;
    line-height: 20px;
    font-family: "Courier New", Courier, monospace;
    white-space: nowrap;
    animation: width 3s steps(17) forwards;
  }

  .text__box::after{
    content: "";
    position: absolute;
    right: 0px;
    height: 16px;
    border-right: 1px solid #fff;
    animation: showInfinite 0.5s 5 both;	/*//	执行5次 */
  }
  .one {
    animation-delay: 0s;
  }
  .two {
    animation-delay: 3s;
  }
  .two::after{
    animation-delay: 3s;
  }
  .three {
    animation-delay: 6s;
  }
  .three::after{
    animation-delay: 6s;
  }
  .four {
    animation-delay: 9s;

  }
  .four::after {
    animation-delay: 9s;

  }
  .five {
    animation-delay: 11s;

  }
  .five::after {
    animation-delay: 11s;

  }
  .six {
    animation-delay: 12s;

  }
  .six::after {
    animation-delay: 12s;

  }
  .seven {
    animation-delay: 13s;

  }
  .seven::after {
    animation-delay: 14s;

  }
  .eight {
    animation-delay: 15s;

  }
  .eight::after {
        animation-delay: 15s;
        animation: showInfinite 0.5s infinite both;
    }
  
  @keyframes width {
    0% {
      width: 0;
    }
    100% {
      width: 17em; /*  单位em,表示一个字体的宽度*/
    }
  }
  @keyframes showInfinite {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }




  .footer{
        position: absolute;
       
        height: 100px;
        top: 40%;
        left: 60%;
        /* border: 2px solid red; */
        /* display: flex; */
        justify-content: center;
        align-items: center;
        text-align: center;
        /* min-height: 100px; */
        /* flex-direction: column; */
        background-image: url("../assets/tick.png");
        width: 0; 
        animation: reveal 0.5s forwards; 
        background-repeat: no-repeat;
    }
    @keyframes reveal { 
        to {
            width: 100px; 
        }
    }
 
  </style>
  
  